import { render } from "./Report4View.vue?vue&type=template&id=7241c524"
import script from "./Report4View.vue?vue&type=script&lang=js"
export * from "./Report4View.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__